import { combine, createStore, createEvent, sample } from 'effector'

import { $authFactors } from 'app/effector/2fa'

// Stores
const $stepNumber = createStore<number>(0)
const $isIssueShown = createStore<boolean>(false)

// Events
const setStep = createEvent<number>()
const goBack = createEvent()
const goNext = createEvent()
const setIssueShown = createEvent<boolean>()

// Store updates
$stepNumber.on(setStep, (state, value) => value)
$isIssueShown.on(setIssueShown, (state, value) => value)

const $hasNextStep = combine($stepNumber, $authFactors, (stepNumber, authFactors) => {
  return stepNumber < authFactors.length - 1
})
const $hasBackStep = combine($stepNumber, (stepNumber) => {
  return stepNumber > 0
})
const $currentStep = combine($stepNumber, $authFactors, (stepNumber, authFactors) => {
  return authFactors[stepNumber]
})

sample({
  clock: goBack,
  source: $stepNumber,
  fn: (stepNumber) => {
    return stepNumber - 1
  },
  target: setStep,
})

sample({
  clock: goNext,
  source: $hasNextStep,
  filter: (hasNextStep) => !hasNextStep,
  fn: () => true,
  target: setIssueShown,
})

sample({
  clock: goNext,
  source: [$hasNextStep, $stepNumber],
  filter: ([hasNextStep]) => !!hasNextStep,
  fn: ([_, stepNumber]) => {
    return stepNumber + 1
  },
  target: setStep,
})

export { $stepNumber, $currentStep, $isIssueShown, $hasNextStep, $hasBackStep, goBack, goNext, setIssueShown }
